import { ContactTopic, PushTopic } from "@seneca/notifications-service-types";

import { NotificationsTopics } from "features/notifications/types";

import {
  EmailNotificationsSourceParamKey,
  NotificationType,
  PushNotificationsSourceParamKey
} from "../consts";

type SourceKeyType =
  | typeof EmailNotificationsSourceParamKey
  | typeof PushNotificationsSourceParamKey
  | null;

export function getAnalyticsDataFromQueryParams(
  searchParams: URLSearchParams
): {
  sourceKey: SourceKeyType | null;
  source: NotificationsTopics | null;
  notificationType: NotificationType | null;
} {
  const emailSource = searchParams.get(EmailNotificationsSourceParamKey);
  const pushSource = searchParams.get(PushNotificationsSourceParamKey);

  if (pushSource) {
    return {
      sourceKey: PushNotificationsSourceParamKey,
      source: pushSource as PushTopic,
      notificationType: NotificationType.PUSH
    };
  }

  if (emailSource) {
    return {
      sourceKey: EmailNotificationsSourceParamKey,
      source: emailSource as ContactTopic,
      notificationType: NotificationType.EMAIL
    };
  }

  return {
    sourceKey: null,
    source: null,
    notificationType: null
  };
}
